import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgHouse = (props, ref) => /* @__PURE__ */ jsxs("svg", { viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#House_svg__a)", fill: "#65BFF1", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M45.632 20.921 41.035 7.935A1.4 1.4 0 0 0 39.714 7H9.595c-.592 0-1.123.374-1.321.935L3.678 20.921a.399.399 0 0 0 .375.533h.777v19.72h39.439v-19.72h.983a.398.398 0 0 0 .375-.533h.005Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M39.714 7H9.595a1.4 1.4 0 0 0-1.321.935L3.678 20.921a.399.399 0 0 0 .375.533h41.2a.398.398 0 0 0 .377-.533L41.032 7.935A1.405 1.405 0 0 0 39.712 7h.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.75,
        d: "M9.341 27.442h10.806c.38 0 .69.31.69.69v13.042H8.654V28.132c0-.38.31-.69.69-.69H9.34Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.55,
        d: "M34.659 7.23a.617.617 0 0 0-.892 0L20.494 21.116c-.145.151-.037.401.171.401h3.484v19.655H44.28V21.518h3.486c.208 0 .316-.25.171-.4L34.658 7.228Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.75,
        d: "M44.277 21.518v-1.445L34.211 9.775 24.145 20.073v1.445H20.66a.237.237 0 0 1-.171-.4L33.765 7.228a.617.617 0 0 1 .892 0l13.275 13.888c.144.151.037.401-.172.401h-3.485.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.85,
        d: "M34.006 18.974a2.393 2.393 0 1 0 0-4.786 2.393 2.393 0 0 0 0 4.786ZM34.213 28.56a3.237 3.237 0 0 1 3.236 3.235v9.38h-6.47v-9.38a3.237 3.237 0 0 1 3.236-3.236h-.002Z"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        opacity: 0.75,
        d: "M2.185 36.635a4.262 4.262 0 0 1 8.14-1.474 3.037 3.037 0 0 1 3.607 2.509h.043a1.753 1.753 0 1 1 0 3.506H2.269A2.27 2.27 0 0 1 0 38.906c0-1.253.97-2.223 2.185-2.269v-.002Z"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "House_svg__a", children: /* @__PURE__ */ jsx("path", { fill: "#fff", transform: "translate(0 7)", d: "M0 0h48v34.174H0z" }) }) })
] });
const ForwardRef = forwardRef(SvgHouse);
export {
  ForwardRef as default
};
